module.exports = __webpack_public_path__ + "media/message.121fb1b7.mp3";